<p-table
  [columns]="selectedColumns"
  [allColumns]="(cols$ | async) || []"
  [value]="rows"
  [loading]="(loading$ | async) ?? true"
  [l10n]="l10n"
  [showCurrentPageReport]="true"
  [showColumnSelector]="true"
  [columnSelectorReorderableColumns]="true"
  [resizableColumns]="true"
  [customSort]="true"
  columnSelectorDataKey="field"
  columnSelectorOptionLabel="header"
  dataKey="tenant_id"
  showCaption="true"
  showColumnSelected="false"
  (onColumnSelectionChange)="onColumnSelectionChange($event)"
  (sortFunction)="onSort($event)"
>
  <ng-template pTemplate="caption">
    <h4 class="notifications-heading">Audit Notification Settings</h4>
    <hr class="notifications-divider" />
  </ng-template>

  <ng-template pTemplate="actionbar">
    <span class="notifications-count"> List of Settings ({{ rows.length }}) </span>
  </ng-template>

  <ng-template pTemplate="header" let-columns>
    <tr>
      @for (col of columns; track col) {
        <th
          id="{{ col.id }}"
          pResizableColumn
          [pResizableColumnDisabled]="!col.resizable"
          [pSortableColumn]="col.field"
          [pSortableColumnDisabled]="!col.sortable"
          [hidden]="!col.visible"
          [style.width]="col.width"
          [style.minWidth]="col.width"
          [title]="col.header"
        >
          <span class="notif-col-header">
            <span class="notif-cell-text" [title]="col.header">{{ col.header }}</span>
            @if (col.sortable) {
              <p-sortIcon [field]="col.field"></p-sortIcon>
            }
          </span>
        </th>
      }
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-row let-columns="columns">
    <tr
      class="notifications-row"
      [class.ui-state-highlight]="selectedRow?.spanva_id === row.tenant_id && !isFlyoutHidden"
      (click)="onRowClick(row)"
      (keyup.enter)="onRowClick(row)"
      (keyup.space)="onRowClick(row)"
      tabindex="0"
      aria-label="View notification settings for {{ row.name }}"
    >
      @for (col of columns; track col) {
        <td class="is--ellipsis" [title]="getCellValue(row, col.field)">
          @switch (col.field) {
            @case ('name') {
              <span class="notif-cell-text notification-name-cell">{{ row.name }}</span>
            }
            @default {
              <span class="notif-cell-text">{{ getCellValue(row, col.field) }}</span>
            }
          }
        </td>
      }
    </tr>
  </ng-template>
</p-table>

@if (selectedRow && selectedInstance) {
  <casb-notifications-details
    [row]="selectedRow"
    [instance]="selectedInstance"
    [settings]="selectedRowSettings"
    [allowedDomains]="allowedDomains"
    [savePending]="(savePending$ | async) ?? false"
    [(isHidden)]="isFlyoutHidden"
    (flyoutClose)="closeFlyout()"
    (save)="onSaveNotification($event)"
  ></casb-notifications-details>
}
